<template>
  <div class="chip-wrapper">
    <color-chip
      v-if="statusConfig"
      :label="statusConfig.label"
      :prefix-icon="statusConfig.icon"
      :icon-pack="statusConfig.iconPack"
      :variant="statusConfig.variant"
      :round="24"
      class="status-chip"
    />
  </div>
</template>

<script>
import ColorChip from "../../../components/ColorChip.vue";

export default {
  name: "CellRendererLicenseStatus",
  components: {
    ColorChip,
  },
  computed: {
    statusConfig() {
      const status =
        this.params && this.params.value ? this.params.value : "none";
      const map = {
        warning: {
          label: "注意",
          icon: "error",
          iconPack: "material-icons",
          variant: "warning",
        },
        caution: {
          label: "警告",
          icon: "warning",
          iconPack: "material-icons",
          variant: "caution",
        },
      };
      return map[status];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.chip-wrapper {
  height: 100%;
  min-width: 70px;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  padding: 8px 0px;
}

.status-chip {
  width: 100%;
  height: 100%;
  padding: 6px 12px;

  :deep(.chip-label) {
    font-weight: 500;
  }
}
</style>
